import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b07f036e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component" }
const _hoisted_2 = { class: "wrapSpHeader" }
const _hoisted_3 = { class: "wrapAllBlogs" }
const _hoisted_4 = { class: "wrapBlog" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "createdAt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlogSpHeader = _resolveComponent("BlogSpHeader")!
  const _component_BlogTag = _resolveComponent("BlogTag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BlogSpHeader, { class: "showHide" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postIndex, (post) => {
        return (_openBlock(), _createElementBlock("div", {
          key: post.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: _ctx.$C.route.blog + '/' + post.id,
              class: "blog"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_5, _toDisplayString(post.title), 1),
                _createElementVNode("p", _hoisted_6, "posted at " + _toDisplayString(_ctx.convertDate(post.created_at)), 1),
                _createVNode(_component_BlogTag, {
                  tags: post.tags,
                  class: "tags"
                }, null, 8, ["tags"])
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]))
      }), 128))
    ])
  ]))
}